export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'googleHomeLedMaskTexture', source: '/assets/googleHomeLedMask.png', type: 'texture' },
            { name: 'googleHomeLedsModel', source: '/assets/googleHomeLedsModel.glb', type: 'model' },
            
            { name: 'loupedeckButtonsModel', source: '/assets/loupedeckButtonsModel.glb', type: 'model' },
            
            { name: 'topChairModel', source: '/assets/topChairModel.glb', type: 'model' },
            
            { name: 'coffeeSteamModel', source: '/assets/coffeeSteamModel.glb', type: 'model' },
            
            { name: 'elgatoLightModel', source: '/assets/elgatoLightModel.glb', type: 'model' },
            
            { name: 'threejsJourneyLogoTexture', source: '/assets/threejsJourneyLogo.png', type: 'texture' },
            
            { name: 'pcScreenModel', source: '/assets/pcScreenModel.glb', type: 'model' },
            
            { name: 'macScreenModel', source: '/assets/macScreenModel.glb', type: 'model' },
            
            /* 站点恒为夜晚（uNightMix=1），day/neutral 复用同一张贴图：浏览器只下载一次，省 ~4MB */
            { name: 'bakedDayTexture', source: '/assets/bakedNightAlt.jpg', type: 'texture' },
            { name: 'bakedNightTexture', source: '/assets/bakedNightAlt.jpg', type: 'texture' },
            { name: 'bakedNeutralTexture', source: '/assets/bakedNightAlt.jpg', type: 'texture' },
            { name: 'lightMapTexture', source: '/assets/lightMap.jpg', type: 'texture' },
            { name: 'roomModel', source: '/assets/roomModel.glb' },
        ]
    }
]